import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { deleteCustomer, logout as apiLogout, logout } from "../middleware/backend_hepler";
import LabeledInput from "./LabeledInput";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DeleteAccountForm = () => {
  const navigate = useNavigate();

  const { adminId } = useParams();
  const [searchParams] = useSearchParams();
  const mobile = searchParams.get("mobile");

  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      admin_id: adminId,
      mobile_number: mobile,
    },
  });

  const { handleSubmit } = methods;

  const onSubmit = async () => {
    try {
      await deleteCustomer(adminId);
      await apiLogout();
      logout();

      navigate("/logout-alert", {
        state: { message: "Account Deleted Successfully" },
      });
    } catch (error) {
      console.error("Delete account error:", error);
      toast.error("Failed to delete account");
    }
  };

  return (
    <div className="edit-all-loan-container  mt-5">
      <div className="edit-back-icon">
        <div
          className="edit-back-text"
          onClick={() => navigate(-1)}
        >
          &lt; Go Back
        </div>
      </div>

      <h2>Delete Account</h2>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="sections personal-details-sections">
            <h4>Account Details</h4>

            <Row>
              <Col md={6}>
                <LabeledInput
                  name="admin_id"
                  label="User ID"
                  disabled={true}
                />
              </Col>

              <Col md={6}>
                <LabeledInput
                  name="mobile_number"
                  label="Mobile Number"
                  disabled
                />
              </Col>
            </Row>
          </div>

          <div className="button-container mt-4 text-center">
            <Button
              variant="primary"
              type="submit"
              onClick={() => navigate(-1)}
              className="custom-next-button"
            >
              cancel
            </Button>
            <Button
              variant="danger"
              type="submit"
              className="custom-close-button"
            >
              Delete
            </Button>
          </div>
        </form>
      </FormProvider>

      <ToastContainer />
    </div>
  );
};

export default DeleteAccountForm;
